import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
import { PersonCompanyRelationType } from "models/enums/auth";
//#endregion
//#region components
import { Grid, Skeleton } from "@mui/material";
import { StyledButton } from "components/common";
import useTipDialog from "./useTipDialog";
import lazyWithReload from "utils/lazyWithReload";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { CompanyService } from "services";
import { CampaignConstants } from "utils/constants";

const BannerImageLazy = lazyWithReload(() => import("./widgetImage"));

const ReferFriend: React.FC<WidgetBaseProps> = (props) => {
  const { openDialog } = useTipDialog();
  const campaignActive = CampaignConstants.isSummerCampaign2026Active(new Date());

  const checkPermission = () =>
    CompanyService.hasRelations([
      PersonCompanyRelationType.SalaryAdmin,
      PersonCompanyRelationType.InvoicesAdmin,
      PersonCompanyRelationType.Contact,
    ]);

  React.useEffect(() => {
    props.onVisibilityChange && props.onVisibilityChange(!checkPermission());
  }, []);

  return checkPermission() ? (
    <Grid container wrap="nowrap" className={cssExports.referFriendBannerContainer} direction="row">
      <Grid item xs className={cssExports.bannerText} container alignItems="center">
        <Grid container spacing={1} direction="column">
          <Grid item className={cssExports.bannerHeaderText}>
            {LocalizationHelperInstance.getFormattedMessage(
              campaignActive
                ? TranslationKeys.Common.ReferFriendWidgetSummer2026
                : TranslationKeys.Common.ReferFriendWidget
            )}
          </Grid>
          <Grid item className={cssExports.bannerDescription}>
            {LocalizationHelperInstance.getFormattedMessage(
              campaignActive
                ? TranslationKeys.Common.ReferFriendWidgetMessageSummer2026
                : TranslationKeys.Common.ReferFriendWidgetMessage
            )}
          </Grid>
          <Grid item>
            <StyledButton size="xs" onClick={openDialog}>
              {LocalizationHelperInstance.getFormattedMessage(
                campaignActive
                  ? TranslationKeys.Common.ReferFriendWidgetButtonSummer2026
                  : TranslationKeys.Common.ReferFriendWidgetButton
              )}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={cssExports.friendWidgetImgContainer}>
        <React.Suspense fallback={<Skeleton style={{ background: "transparent" }}></Skeleton>}>
          <BannerImageLazy />
        </React.Suspense>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default ReferFriend;
